import { render } from "./wxmcontact.vue?vue&type=template&id=674dd848&scoped=true"
import script from "./wxmcontact.vue?vue&type=script&lang=js"
export * from "./wxmcontact.vue?vue&type=script&lang=js"

import "./wxmcontact.vue?vue&type=style&index=0&id=674dd848&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674dd848"]])

export default __exports__